import { render, staticRenderFns } from "./padded-container.vue?vue&type=template&id=1beac890&scoped=true&functional=true"
import script from "./padded-container.vue?vue&type=script&lang=js"
export * from "./padded-container.vue?vue&type=script&lang=js"
import style0 from "./padded-container.vue?vue&type=style&index=0&id=1beac890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "1beac890",
  null
  
)

export default component.exports